import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { showToast } from "../../utils/helper";

import {
  getCurrentAccount,
  getNotifications,
  getAuthorizationsLoaded,
  getNotificationsLoaded,
  getNotificationsLoading,
  getSession,
} from "../../reducers/selectors";
import { notificationsReload } from "../../actions/entities";
import { Popup } from "../Modal/Popup/Popup";
import SidebarOnboarding from "../SidebarOnboarding/Sidebaronboarding";
import { Toaster } from "../Toaster/Toaster";

export const PopupWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const notifications = useSelector(getNotifications);
  const [activeNotification, setActiveNotification] = useState(null);

  const notificationsOrder = {
    FirstAccess: 0,
    Suitability: 1,
    PersonalData: 2,
    BlockingPopup: 3,
    Popup: 4,
    Alert: 5,
    Notification: 6,
  };

  useEffect(() => {
    if (notifications) {
      if (notifications.length) {
        const newNotifications = notifications.sort((a, b) => {
          if (notificationsOrder[a.InternalMessageForm] > notificationsOrder[b.InternalMessageForm]) return 1;
          if (notificationsOrder[a.InternalMessageForm] < notificationsOrder[b.InternalMessageForm])
            return -1;
          return 0;
        });

        if (notificationsOrder[newNotifications[0].InternalMessageForm] <= 2)
          setActiveNotification(newNotifications[0]);
        else {
          setActiveNotification(null);
        }
      }
    }
  }, [notifications]);

  const toggleActiveNotification = () => {
    setActiveNotification(null);
  };

  return !activeNotification ? (
    <Fragment>{children}</Fragment>
  ) : (
    <Fragment>
      <Toaster />
      {activeNotification.InternalMessageForm === "FirstAccess" ? (
        <Fragment>
          <SidebarOnboarding></SidebarOnboarding>
        </Fragment>
      ) : (
        <Fragment>
          <Popup
            internalMessage={activeNotification}
            open={!!activeNotification}
            toggle={toggleActiveNotification}
            isBlocking={activeNotification.InternalMessageForm === "BlockingPopup"}
          />
          {!activeNotification.InternalMessageForm === "BlockingPopup" && <Fragment>{children}</Fragment>}
        </Fragment>
      )}
    </Fragment>
  );
};
